import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { rem } from 'polished';
import styled from 'styled-components';

import { APP_ELEMENT_ID } from 'constants/layout';
import { breakpoints, misc } from 'helpers/styles/constants';
import DashboardFooter from 'components/Dashboard/Footer/Footer';

import App from './App';

const Dashboard = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.pageBg};
`;

const DashboardContent = styled.div`
  @media ${breakpoints.smUp} {
    display: flex;
    min-height: calc(100vh - ${rem(misc.dashboardFooterHeight)});
  }
`;

export interface Props {
  children: React.ReactChild | React.ReactChild[];
}

const AuthApp = ({ children }: Props) => (
  <BrowserRouter>
    <App>
      <Dashboard id={APP_ELEMENT_ID}>
        <DashboardContent>{children}</DashboardContent>
        <DashboardFooter />
      </Dashboard>
    </App>
  </BrowserRouter>
);

export default AuthApp;
